import { Component, OnInit } from '@angular/core';
import { LazyLoadEvent, SelectItem } from 'primeng/primeng';
import { Router } from '@angular/router';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { DatePipe } from '@angular/common';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { GetReportingToService } from 'app/shared/common/helper/get-reporting-to';

@Component({
  selector: 'app-activity-center',
  templateUrl: './activity-center.component.html',
  styleUrls: ['./activity-center.component.scss']
})

export class ActivityCenterComponent implements OnInit {

  totalRecords: number;
  loading: boolean;
  loadEventData: LazyLoadEvent;
  firstname: String;
  lastname: String;
  public paginationNumberFormatter;
  value: any;
  public paginationPageSize;
  rowData = [];
  cols: any[];
  tabIndex: number;
  moduleType: string;
  empRole = '';
  userId = this.parseService.instance.User.current().id;
  profileId = '';
  idArray = [];
  reportingList = [];
  reportingToDD = [];
  reportingToOptions: SelectItem[];
  colsaddon: any[];
  colsclient: any[];
  colsemployee: any[];
  colsopportunity: any[];
  fromDateProject: any;
  toDateProject: any;
  fromDateAddon: any;
  toDateAddon: any;
  fromDateClient: any;
  toDateClient: any;
  fromDateEmployee: any;
  toDateEmployee: any;
  fromDateOpportunity: any;
  toDateOpportunity: any;
  selectedProjectReporter = '';
  selectedAddonReporter = '';
  selectedClientReporter = '';
  selectedEmployeeReporter = '';
  selectedOpportunityReporter = '';
  tenantId: any;

  constructor(
    private router: Router,
    private parseService: ParseService,
    private queryInterface: QueryInterface,
    private storageConfiguration: StorageConfiguration,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private getReportingToService: GetReportingToService
  ) {
    this.cols = [
      { header: 'S.No', field: 'position' },
      { header: 'updatedUserUrl', field: 'updatedUserUrl' },
      { header: 'Activity By', field: 'updatedBy' },
      { header: 'Project Name', field: 'name' },
      { header: 'Message', field: 'message' }
    ];

    this.colsaddon = [
      { header: 'S.No', field: 'position' },
      { header: 'updatedUserUrl', field: 'updatedUserUrl' },
      { header: 'Activity By', field: 'updatedBy' },
      { header: 'Addon Name', field: 'name' },
      { header: 'Message', field: 'message' }
    ];

    this.colsclient = [
      { header: 'S.No', field: 'position' },
      { header: 'updatedUserUrl', field: 'updatedUserUrl' },
      { header: 'Activity By', field: 'updatedBy' },
      { header: 'Client Name', field: 'name' },
      { header: 'Message', field: 'message' }
    ];

    this.colsemployee = [
      { header: 'S.No', field: 'position' },
      { header: 'updatedUserUrl', field: 'updatedUserUrl' },
      { header: 'Activity By', field: 'updatedBy' },
      { header: 'Employee Name', field: 'name' },
      { header: 'Message', field: 'message' }
    ];

    this.colsopportunity = [
      { header: 'S.No', field: 'position' },
      { header: 'updatedUserUrl', field: 'updatedUserUrl' },
      { header: 'Activity By', field: 'updatedBy' },
      { header: 'Opportunity Name', field: 'name' },
      { header: 'Message', field: 'message' }
    ]
  }

  async ngOnInit() {
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
    this.profileId = this.parseService.instance.User.current().get('profile').id;
    this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
    await this.getProjects();
    this.getReportingTo();
    this.tabChange(0);
  }

  async getReportingTo() {
    await this.getReportingToService.getReportingTo().then(res => {
      this.reportingToOptions = res;
    });
  }

  uniqBy(a, key) {
    var index = [];
    return a.filter(function (item) {
      var k = key(item);
      return index.indexOf(k) >= 0 ? false : index.push(k);
    });
  }

  bindDropDown(array: any[]): any[] {
    const dropDownItem = [];
    array.forEach(a => {
      dropDownItem.push({ label: a.name, value: a.id });
    });
    return dropDownItem;
  }

  async getProjects() {
    this.idArray = [];
    let resultId = [];
    if (this.empRole == 'Leader') {
      let queryInstance = this.parseService.instance.Object.extend('ProjectMembers');
      let query = new this.parseService.instance.Query(queryInstance);
      query.equalTo("user", { __type: "Pointer", className: "_User", objectId: this.userId });
      query.include("project")
      query.include("project.client");
      query.equalTo('status', 'Assigned');
      query.equalTo('tenantId', this.tenantId);
      await query.find().then(async res => {
        res.forEach(element => {
          if (element.get('project').id != undefined) {
            resultId.push(element.get('project').id);
          }
        });
        let queryInstanceProfile = this.parseService.instance.Object.extend('Profile');
        let queryProfile = new this.parseService.instance.Query(queryInstanceProfile);
        queryProfile.equalTo("reportingTo", { __type: "Pointer", className: "Profile", objectId: this.profileId });
        queryProfile.equalTo("isActive", true);
        queryProfile.equalTo('tenantId', this.tenantId);
        await queryProfile.find().then(result => {
          result.forEach(element => {
            resultId.push(element.id);
          });
        });
      });
      this.idArray = resultId;
    }
  }

  async projectFilter() {
    let startEndDateProject;
    if (this.fromDateProject == undefined || this.fromDateProject == '') {
      this.toastr.warning('Please select the from date');
      startEndDateProject = [];
    } else if (this.fromDateProject != undefined && this.fromDateProject != '') {
      let startDate = this.startenddates1(this.fromDateProject);
      let endDate = this.startenddates1((this.toDateProject == undefined || this.toDateProject == '') ? new Date() : this.toDateProject);
      startEndDateProject = [startDate[0], endDate[1]];
      await this.getActivities(this.moduleType, startEndDateProject);
    }
  }

  async addonFilter() {
    let startEndDateAddon;
    if (this.fromDateAddon == undefined || this.fromDateAddon == '') {
      this.toastr.warning('Please select the from date');
      startEndDateAddon = [];
    } else if (this.fromDateAddon != undefined && this.fromDateAddon != '') {
      let startDate = this.startenddates1(this.fromDateAddon);
      let endDate = this.startenddates1((this.toDateAddon == undefined || this.toDateAddon == '') ? new Date() : this.toDateAddon);
      startEndDateAddon = [startDate[0], endDate[1]];
      await this.getActivities(this.moduleType, startEndDateAddon);
    }
  }

  async clientFilter() {
    let startEndDateClient;
    if (this.fromDateClient == undefined || this.fromDateClient == '') {
      this.toastr.warning('Please select the from date');
      startEndDateClient = [];
    } else if (this.fromDateClient != undefined && this.fromDateClient != '') {
      let startDate = this.startenddates1(this.fromDateClient);
      let endDate = this.startenddates1((this.toDateClient == undefined || this.toDateClient == '') ? new Date() : this.toDateClient);
      startEndDateClient = [startDate[0], endDate[1]];
      await this.getActivities(this.moduleType, startEndDateClient);
    }
  }

  async employeeFilter() {
    let startEndDateEmployee;
    if (this.fromDateEmployee == undefined || this.fromDateEmployee == '') {
      this.toastr.warning('Please select the from date');
      startEndDateEmployee = [];
    } else if (this.fromDateEmployee != undefined && this.fromDateEmployee != '') {
      let startDate = this.startenddates1(this.fromDateEmployee);
      let endDate = this.startenddates1((this.toDateEmployee == undefined || this.toDateEmployee == '') ? new Date() : this.toDateEmployee);
      startEndDateEmployee = [startDate[0], endDate[1]];
      await this.getActivities(this.moduleType, startEndDateEmployee);
    }
  }

  async opportunityFilter() {
    let startEndDateOpportunity;
    if (this.fromDateOpportunity == undefined || this.fromDateOpportunity == '') {
      this.toastr.warning('Please select the from date');
      startEndDateOpportunity = [];
    } else if (this.fromDateOpportunity != undefined && this.fromDateOpportunity != '') {
      let startDate = this.startenddates1(this.fromDateOpportunity);
      let endDate = this.startenddates1((this.toDateOpportunity == undefined || this.toDateOpportunity == '') ? new Date() : this.toDateOpportunity);
      startEndDateOpportunity = [startDate[0], endDate[1]];
      await this.getActivities(this.moduleType, startEndDateOpportunity);
    }
  }

  // async tabChange(index): Promise<void> {
  //   if (index == 0) {
  //     this.tabIndex = 0;
  //     this.moduleType = 'Project';
  //     this.fromDateProject = '';
  //     this.toDateProject = '';
  //     await this.getActivities(this.moduleType, []);
  //     this.selectedProjectReporter = '';
  //   }
  //   else if (index == 1) {
  //     this.tabIndex = 1;
  //     this.moduleType = 'Sub-Project';
  //     this.fromDateAddon = '';
  //     this.toDateAddon = '';
  //     await this.getActivities(this.moduleType, []);
  //     this.selectedAddonReporter = '';
  //   }
  //   else if (index == 2) {
  //     this.tabIndex = 2;
  //     this.moduleType = 'Client';
  //     this.fromDateClient = '';
  //     this.toDateClient = '';
  //     await this.getActivities(this.moduleType, []);
  //     this.selectedClientReporter = '';
  //     if (this.empRole == 'Leader') {
  //       this.tabIndex = 3;
  //       this.moduleType = 'Profile-View';
  //       this.fromDateEmployee = '';
  //       this.toDateEmployee = '';
  //       await this.getActivities(this.moduleType, []);
  //       this.selectedEmployeeReporter = '';
  //     }
  //   }
  //   else if (index == 3) {
  //     this.tabIndex = 3;
  //     this.moduleType = 'Profile-View';
  //     this.fromDateEmployee = '';
  //     this.toDateEmployee = '';
  //     await this.getActivities(this.moduleType, []);
  //     this.selectedEmployeeReporter = '';
  //     if (this.empRole == 'Leader') {
  //       this.tabIndex = 4;
  //       this.moduleType = 'Opportunity';
  //       this.fromDateOpportunity = '';
  //       this.toDateOpportunity = '';
  //       await this.getActivities(this.moduleType, []);
  //       this.selectedOpportunityReporter = '';
  //     }
  //   }
  //   else if (index == 4) {
  //     this.tabIndex = 4;
  //     this.moduleType = 'Opportunity';
  //     this.fromDateOpportunity = '';
  //     this.toDateOpportunity = '';
  //     await this.getActivities(this.moduleType, []);
  //     this.selectedOpportunityReporter = '';
  //   }
  // }

  async tabChange(index): Promise<void> {
      if (index == 0) {
        this.tabIndex = 0;
        this.moduleType = 'Project';
        this.fromDateProject = '';
        this.toDateProject = '';
        await this.getActivities(this.moduleType, []);
        this.selectedProjectReporter = '';
      }
      else if (index == 1) {
        this.tabIndex = 1;
        this.moduleType = 'Client';
        this.fromDateClient = '';
        this.toDateClient = '';
        await this.getActivities(this.moduleType, []);
        this.selectedClientReporter = '';
        if (this.empRole == 'Leader') {
          this.tabIndex = 3;
          this.moduleType = 'Profile-View';
          this.fromDateEmployee = '';
          this.toDateEmployee = '';
          await this.getActivities(this.moduleType, []);
          this.selectedEmployeeReporter = '';
        }
      }
      else if (index == 2) {
        this.tabIndex = 2;
        this.moduleType = 'Profile-View';
        this.fromDateEmployee = '';
        this.toDateEmployee = '';
        await this.getActivities(this.moduleType, []);
        this.selectedEmployeeReporter = '';
        if (this.empRole == 'Leader') {
          this.tabIndex = 4;
          this.moduleType = 'Opportunity';
          this.fromDateOpportunity = '';
          this.toDateOpportunity = '';
          await this.getActivities(this.moduleType, []);
          this.selectedOpportunityReporter = '';
        }
      }
    }

  async getActivities(moduleType, startEndDate) {
    this.spinner.show();
    await this.getProjects();
    this.rowData = [];
    this.totalRecords = await this.getResourcesCount(startEndDate);
    let condition = [
      { condition: 'descending', field: 'createdAt' },
      { condition: 'limit', value: 25 },
      { condition: 'include', value: 'updatedBy' },
      { condition: "equalTo", field: "moduleType", value: moduleType },
      { condition: 'equalTo', field: 'tenantId', value: this.tenantId }
    ]
    if (startEndDate.length > 0 && startEndDate != undefined) {
      condition.push({ condition: 'greaterThan', field: 'createdAt', value: startEndDate[0] },
        { condition: 'lessThan', field: 'createdAt', value: startEndDate[1] })
    }
    if (this.empRole == 'Leader') {
      condition.push(
        { condition: "containedIn", field: "updatedId", value: this.idArray }
      );
    }
    await this.queryInterface.executeQuery(this.parseService, 'ActivityCenter', condition).then(results => {
      this.loadResources(results, 0).then((res: any) => {
        this.rowData = res.sort((a, b) => {
          if ((a.createdAt).getTime() > (b.createdAt).getTime()) { return -1; }
          if ((a.createdAt).getTime() < (b.createdAt).getTime()) { return 1; }
        });
        this.spinner.hide();
      });
    });
  }

  async loadResources(results, skip) {
    let activity = [];
    let i = skip;
    for (const element of results) {
      let name;
      let message;
      let datePipe = new DatePipe('en-US');

      if (element.get('moduleType') == 'Project') {
        let queryInstance = this.parseService.instance.Object.extend('Project');
        let query = new this.parseService.instance.Query(queryInstance);
        query.equalTo('objectId', element.get('updatedId'));
        query.equalTo('tenantId', this.tenantId);
        await query.find().then(res => {
          let projectResult = res[0];
          name = projectResult != undefined ? projectResult.get('projectInfo').projectName : '';
          message = element.get('message') + '<div style="font-size: 12px; !important">' + datePipe.transform(element.get('createdAt'), 'medium') + '</div>';
        });
      }

      // if (element.get('moduleType') == 'Sub-Project') {
      //   let queryInstance = this.parseService.instance.Object.extend('Project');
      //   let query = new this.parseService.instance.Query(queryInstance);
      //   query.equalTo('objectId', element.get('updatedId'));
      //   query.equalTo('tenantId', this.tenantId);
      //   await query.find().then(res => {
      //     let addonResult = res[0];
      //     name = addonResult != undefined ? addonResult.get('projectInfo').projectName : '';
      //     message = element.get('message') + '<div style="font-size: 12px; !important">' + datePipe.transform(element.get('createdAt'), 'medium') + '</div>';
      //   });
      // }

      if (element.get('moduleType') == 'Client') {
        let queryInstance = this.parseService.instance.Object.extend('Client');
        let query = new this.parseService.instance.Query(queryInstance);
        query.equalTo('objectId', element.get('updatedId'));
        query.equalTo('tenantId', this.tenantId);
        await query.find().then(res => {
          let clientResult = res[0];
          name = clientResult != undefined ? clientResult.get('companyInfo').firstName + ' ' + clientResult.get('companyInfo').lastName : '';
          message = element.get('message') + '<div style="font-size: 12px; !important">' + datePipe.transform(element.get('createdAt'), 'medium') + '</div>';
        });
      }

      if (element.get('moduleType') == 'Profile-View') {
        let queryInstance = this.parseService.instance.Object.extend('Profile');
        let query = new this.parseService.instance.Query(queryInstance);
        query.equalTo('objectId', element.get('updatedId'));
        query.equalTo('tenantId', this.tenantId);
        await query.find().then(res => {
          let profileResult = res[0];
          name = profileResult != undefined ? profileResult.get('firstName') + ' ' + profileResult.get('lastName') : '';
          message = element.get('message') + '<div style="font-size: 12px; !important">' + datePipe.transform(element.get('createdAt'), 'medium') + '</div>';
        });
      }

      // if (element.get('moduleType') == 'Opportunity') {
      //   let queryInstance = this.parseService.instance.Object.extend('Enquiry');
      //   let query = new this.parseService.instance.Query(queryInstance);
      //   query.equalTo('objectId', element.get('updatedId'));
      //   await query.find().then(res => {
      //     let profileResult = res[0];
      //     name = profileResult.get('enquiryName');
      //     message = element.get('message') + '<div style="font-size: 12px; !important">' + datePipe.transform(element.get('createdAt'), 'medium') + '</div>';
      //   });
      // }

      i = i + 1;
      activity.push({
        // position: i,
        moduleType: element.get('moduleType'),
        message: message,
        updatedBy: element.get('updatedBy').get('firstName') + ' ' + element.get('updatedBy').get('lastName'),
        updatedUserUrl: element.get('updatedBy').get('profileImageInfo').url,
        id: element.get('updatedId'),
        name: name,
        createdAt: element.get('createdAt')
      });
    }
    return activity;
  }

  async onLazyLoadResources(event: LazyLoadEvent) {
    this.rowData = [];
    this.loading = true;
    await this.getProjects();
    this.loadEventData = event;
    let condition = [];

    if (this.empRole == 'Leader') {
      condition.push(
        { condition: "containedIn", field: "updatedId", value: this.idArray }
      );
    }

    const filter: any = event.filters;
    if (!filter) {
      const skip: number = event.first;
      condition.push({ condition: 'skip', value: event.first },
        { condition: 'descending', field: 'createdAt' });
      this.totalRecords = await this.getTotalRecordCount(condition);
      this.lazyLoadAddResources(condition, skip, event.rows);
    } else {
      // tslint:disable-next-line:forin
      for (let key in filter) {
        let filterValue = filter[key].value;
        if (!(filterValue.length < 1)) {

          if (key == 'updatedBy') {
            condition.push({ condition: 'containedIn', field: key, value: filter[key].value });
          }
          if (key != 'updatedBy') {
            filterValue = filter[key].value.replace(/\b\w/g, l => l.toUpperCase());
            condition.push({ condition: 'contains', field: key, value: filterValue });
          }
        }
      }
      condition.push({ condition: 'skip', value: event.first });
      this.totalRecords = await this.getTotalRecordCount(condition);
      if (this.totalRecords < event.first) {
        event.first = 0;
      }
      this.lazyLoadAddResources(condition, event.first, event.rows);
    }
  }

  lazyLoadAddResources(condition, skip, limit) {
    if (this.empRole == 'Leader') {
      condition.push(
        { condition: "containedIn", field: "updatedId", value: this.idArray }
      );
    }
    condition.push({ condition: 'limit', value: limit },
      { condition: 'include', value: 'updatedBy' },
      { condition: 'descending', field: 'createdAt' },
      { condition: "equalTo", field: "moduleType", value: this.moduleType },
      { condition: 'equalTo', field: 'tenantId', value: this.tenantId },
    );
    this.queryInterface.executeQuery(this.parseService, 'ActivityCenter', condition)
      .then(results => {
        this.loadResources(results, skip).then((res: any) => {
          this.rowData = res.sort((a, b) => {
            if ((a.createdAt).getTime() > (b.createdAt).getTime()) { return -1; }
            if ((a.createdAt).getTime() < (b.createdAt).getTime()) { return 1; }
          });
          this.loading = false;
        });
      });
  }

  getTotalRecordCount(condition) {
    condition.push({ condition: "equalTo", field: "moduleType", value: this.moduleType },
      { condition: 'descending', field: 'createdAt' },
      { condition: 'equalTo', field: 'tenantId', value: this.tenantId}
    );
    return this.queryInterface.getQueryCount(this.parseService, 'ActivityCenter', condition);
  }

  getResourcesCount(startEndDate) {
    let condition = [];
    condition = [
      { condition: "equalTo", field: "moduleType", value: this.moduleType },
      { condition: 'descending', field: 'createdAt' },
      { condition: 'include', value: 'updatedBy' },
      { condition: 'equalTo', field: 'tenantId', value: this.tenantId}
    ];
    if (startEndDate.length > 0 && startEndDate != undefined) {
      condition.push({ condition: 'greaterThan', field: 'createdAt', value: startEndDate[0] },
        { condition: 'lessThan', field: 'createdAt', value: startEndDate[1] })
    }
    if (this.empRole == 'Leader') {
      condition.push(
        { condition: "containedIn", field: "updatedId", value: this.idArray }
      );
    }
    return this.queryInterface.getQueryCount(this.parseService, 'ActivityCenter', condition);
  }

  goToDetails(id, moduleType) {
    if (moduleType == 'Project' || moduleType == 'Sub-Project') {
      // this.router.navigate(['project-detail', { id: id, projectType : moduleType }]);
      this.router.navigate(['project-detail', { id: id }]);
    }
    else if (moduleType == 'Client') {
      this.router.navigate(['client-create', { id: id }]);
    }
    else if (moduleType == 'Profile-View') {
      this.router.navigate(['profile-view', { id: id }]);
    }
  }

  async clearFilter() {
    if (this.tabIndex == 0) {
      this.tabIndex = 0;
      this.moduleType = 'Project';
      await this.getActivities(this.moduleType, []);
      this.selectedProjectReporter = '';
    }
    // else if (this.tabIndex == 1) {
    //   this.tabIndex = 1;
    //   this.moduleType = 'Sub-Project';
    //   await this.getActivities(this.moduleType, []);
    //   this.selectedAddonReporter = '';
    // }
    else if (this.tabIndex == 1) {
      this.tabIndex = 1;
      this.moduleType = 'Client';
      await this.getActivities(this.moduleType, []);
      this.selectedClientReporter = '';
      if (this.empRole == 'Leader') {
        this.tabIndex = 3;
        this.moduleType = 'Profile-View';
        await this.getActivities(this.moduleType, []);
        this.selectedEmployeeReporter = '';
      }
    }
    else if (this.tabIndex == 2) {
      this.tabIndex = 2;
      this.moduleType = 'Profile-View';
      await this.getActivities(this.moduleType, []);
      this.selectedEmployeeReporter = '';
      if (this.empRole == 'Leader') {
        this.tabIndex = 4;
        this.moduleType = 'Opportunity';
        await this.getActivities(this.moduleType, []);
        this.selectedOpportunityReporter = '';
      }
    }
    // else if (this.tabIndex == 4) {
    //   this.tabIndex = 4;
    //   this.moduleType = 'Opportunity';
    //   await this.getActivities(this.moduleType, []);
    //   this.selectedOpportunityReporter = '';
    // }
  }

  nextDay(d) {
    let day = new Date(d);
    return new Date(day.setDate(day.getDate() + 1));
  }

  prevDay(d) {
    let day = new Date(d);
    return new Date(day.setDate(day.getDate() - 1));
  }

  startenddates1(day) {
    let startdate = this.prevDay(new Date(day));
    startdate.setHours(23, 59, 59, 999);
    let enddate = this.nextDay(day);
    enddate.setHours(0, 0, 0, 0);
    return [startdate, enddate];
  }

  getToday(): string {
    return new Date().toISOString().split('T')[0];
  }

}
